import { COLORS } from '@/constants';
import { Button, Typography } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.article<{ $isProject?: boolean; $compact?: boolean }>`
  display: flex;
  width: 100%;
  align-items: stretch;
  height: ${({ $isProject, $compact }) => ($isProject ? 'auto' : $compact ? '200px' : '260px')};
  min-height: ${({ $isProject }) => ($isProject ? '420px' : '280px')};

  @media (max-width: 640px) {
    height: 200px;
    min-height: unset;
  }
`;

export const ImageWrapper = styled.div<{ $isProject?: boolean; $compact?: boolean }>`
  position: relative;
  flex-shrink: 0;
  background: #eeeeee;
  border-radius: 6px 0 0 6px;
  border: 1px solid ${COLORS['neutral/300']};
  border-right: none;
  min-width: ${({ $compact }) => ($compact ? '220px' : '385px')};
  width: ${({ $compact }) => ($compact ? '220px' : '385px')};
  height: ${({ $isProject }) => ($isProject ? 'auto' : 'unset')};
  align-self: ${({ $isProject }) => ($isProject ? 'auto' : 'stretch')};

  @media (max-width: 1100px) {
    width: ${({ $isProject }) => ($isProject ? '340px' : '38%')};
    min-width: ${({ $isProject }) => ($isProject ? '340px' : '38%')};
  }

  @media (max-width: 960px) {
    width: 38%;
    min-width: 38%;
  }

  img {
    height: 100%;
    object-fit: cover;
    object-position: center;
    background-repeat: no-repeat;
    border-radius: 6px 0 0 6px;

    @media (max-width: 960px) {
      min-width: 0px;
    }
  }
`;

export const Image = styled.img``;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 16px;
  gap: 10px;
  padding-left: 20px;
  border: 1px solid ${COLORS['neutral/300']};
  border-left: none;
  flex: 1;
  border-radius: 0px 6px 6px 0px;
  position: relative;
  min-width: 0;
  overflow: hidden;

  @media (max-width: 640px) {
    padding: 10px 12px;
  }
`;

export const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow: hidden;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 8px;
`;

export const CardHead = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 60px;
  min-width: 0;

  @media (max-width: 640px) {
    padding-right: 0;
  }
`;

export const ShareBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ShareBtnBox = styled.div`
  display: flex;
  gap: 6px;
  height: 32px;
`;

export const ButtonCopyStyled = styled(Button)<{ $isCopied?: boolean }>`
  &.MuiButtonBase-root.MuiButton-root {
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    padding: 0;
    background: ${(props) => (props.$isCopied ? COLORS.white : COLORS.yellow)};
    color: ${(props) => (props.$isCopied ? COLORS.yellow : COLORS.white)};
    border-color: ${COLORS.yellow};
    transparent: ${(props) => (props.$isCopied ? 1 : 9.8)};
    border-width: 2px;

    svg {
      width: 20px;
      height: 20px;
      color: ${(props) => (props.$isCopied ? COLORS.yellow : COLORS.white)};
    }
  }
`;

export const ButtonsBox = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  position: absolute;
  right: 20px;
  top: 16px;

  @media (max-width: 640px) {
    display: none;
  }
`;

export const ProjectGalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 3fr 1fr 1fr;
  gap: 8px;
  padding: 16px 0 16px 16px;
  position: absolute;
  inset: 0;
  border-radius: 6px 0 0 6px;
  overflow: hidden;
  background: #fff;

  @media (max-width: 960px) {
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

export const ProjectGalleryMain = styled.div`
  grid-column: 1 / 4;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  background: #eeeeee;

  @media (max-width: 960px) {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
  }
`;

export const ProjectGalleryThumb = styled.div<{ $index?: number; $empty?: boolean }>`
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  background: ${({ $empty }) => ($empty ? 'transparent' : '#d8dde8')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 960px) {
    ${({ $index = 0 }) => $index >= 2 && 'display: none;'}
  }
`;

export const ProjectGalleryMore = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(21, 27, 40, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;

export const ProjectObjectsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid ${COLORS['neutral/200']};
  border-radius: 6px;
  overflow: hidden;
`;

export const ProjectObjectsRow = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  text-decoration: none;
  border-bottom: 1px solid ${COLORS['neutral/200']};
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${COLORS['neutral/50']};
  }
`;

export const ProjectObjectThumb = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  background: #eeeeee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProjectObjectsTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
`;

export const ProjectBrokerBlock = styled.div`
  @media (max-width: 1100px) {
    display: none;
  }
`;

export const ProjectBottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding: 10px;
  background: ${COLORS['neutral/50']};
  border: 1px solid ${COLORS['neutral/200']};
  border-radius: 4px;
`;

export const ProjectQuickRequestButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background: ${COLORS['secondary/500']};
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  height: 34px;
  box-sizing: border-box;
  transition: background 0.2s ease;

  &:hover {
    background: ${COLORS['secondary/700']};
  }
`;

export const ProjectViewButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  height: 34px;
  box-sizing: border-box;
  border: 2px solid ${COLORS['primary/600']};
  border-radius: 6px;
  background: ${COLORS.white};
  color: ${COLORS['primary/600']};
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: ${COLORS['primary/600']};
    color: #ffffff;
    svg path {
      stroke: #ffffff;
    }
  }
`;

export const StyledButton = styled(Button)`
  && {
    border-radius: 6px;
    width: 34px;
    height: 34px;
    padding: 0;
    min-width: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS['neutral/300']};
    cursor: pointer;
    border: 1px solid ${COLORS['neutral/300']};
    color: ${COLORS['neutral/300']};
    &:hover {
      svg {
        transform: scale(1.15);
      }
    }
    svg {
      transition:
        transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1),
        fill 0.22s ease,
        stroke 0.22s ease;
    }
  }
`;

// Shared truncation mixin used by title/description
const clampedText = `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
`;

export const CardTitle = styled(Typography)`
  && {
    ${clampedText}
    -webkit-line-clamp: 1;
  }
`;

export const CardDescription = styled(Typography)`
  && {
    ${clampedText}
    -webkit-line-clamp: 2;
    overflow-wrap: break-word;
    padding: 4px 0;
  }
`;

export const DescriptionBox = styled.div`
  max-width: 100%;
  min-width: 0;
  padding: 4px 0;
  padding-right: 60px;
  @media (max-width: 600px) {
    padding-right: 0;
  }
`;

// Project card styled components
export const ProjectOfficeName = styled(Typography)`
  && {
    background: ${COLORS['primary/50']};
    border-radius: 4px;
    padding: 8px 16px;
    margin-right: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ProjectCardTitle = styled(Typography)`
  && {
    ${clampedText}
    -webkit-line-clamp: 1;
  }
`;

export const ProjectCardDescription = styled(Typography)`
  && {
    ${clampedText}
    -webkit-line-clamp: 2;
    padding: 4px 0;
  }
`;

export const BrokerInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const BrokerImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: contain;
  flex-shrink: 0;
  border: 1px solid ${COLORS['neutral/200']};
`;

export const BrokerInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ProjectButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ProjectSkeletonGallery = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 385px;
  min-width: 385px;
  align-self: stretch;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 3fr 1fr 1fr;
  gap: 8px;
  padding: 16px 0 16px 16px;
  background: #fff;
  border-radius: 6px 0 0 6px;
  border: 1px solid ${COLORS['neutral/300']};
  border-right: none;

  @media (max-width: 1100px) {
    width: 340px;
    min-width: 340px;
  }

  @media (max-width: 960px) {
    width: 38%;
    min-width: 38%;
  }
`;

export const SkeletonBrokerInfo = styled.div`
  flex: 1;
`;
